import type { RegisterOptions } from 'react-hook-form'
import type { TriggerInputField } from '@/types/workflowDefinition'

/**
 * react-hook-form rules for a free-text trigger input, shared by the trigger dialog and the chat
 * trigger form so both surfaces enforce the same constraints. The trim check matters because the
 * server rejects whitespace-only values on `IsNullOrWhiteSpace`, while react-hook-form's `required`
 * is satisfied by a single space — without it one surface would send a submission the API refuses.
 */
export function buildTextFieldRules<TFormValues extends Record<string, string>>(
  field: TriggerInputField,
  label: string,
): RegisterOptions<TFormValues> | undefined {
  if (!field.required) return undefined

  return {
    required: `${label} is required`,
    validate: (value: string) => (value.trim().length === 0 ? `${label} is required` : true),
  }
}
